import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import Results from '~/pages/Farmer/Co2Climate/AnswerCO2Climate/Steps/Results'
import { FarmersService } from '~/api/services/farmers'

interface Props {
  id: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
  farmerId: string
}

const PreviewModal: React.FC<Props> = (props) => {
  const { id, handleClose, uniqueId, farmerId } = props
  const { t } = useTranslation()

  const [submitPreviewData, setSubmitPreviewData] = useState(false)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (id) {
      fetchPreviewData()
    }
  }, [id])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await FarmersService.getCO2FooprintData(farmerId, id)
      setSubmitPreviewData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(id)}
    isLoading={isBusy}
    style={{ width: '80%' }}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      <Results results={submitPreviewData} removeMargin />
    </>}
    handleClose={() => handleClose()}
    textClose={t('Close')}
  />

}
export default PreviewModal